




























































































































































































































































import { Component } from 'vue-property-decorator';
import { HeaderList, List } from '@/components/Table/TableModel';
import {
  CustomSelectModel,
  CustomSelectGroup,
  CustomSelectOption
} from '@/components/CustomSelect/CustomSelectModel';
import RowsTable from '@/components/Table/RowsTable.vue';
import AdminService from '@/api/AdminService';
import BasePagination from '@/components/BasePagination/BasePagination.vue';
import ContextMenu from '@/components/ContextMenu/ContextMenu.vue';
import ContextMenuOption from '@/components/ContextMenu/ContextMenuOption';
import TextInput from '@/components/TextInput/TextInput.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import eventBus from '@/utils/eventBus';
import ContentContainer from '@/components/molecules/ContentContainer/ContentContainer.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';

import Table from '@/components/molecules/Table/Table.vue';
import TableFilters from '@/components/molecules/TableFilters/TableFilters.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import UserIcon from '@/components/molecules/UserIcon/UserIcon.vue';
import { EBusinessStatus } from '@/models/business';
import DateUtils from '@/utils/DateUtils';
import { getBusinessLocationInfo } from '@/utils/businessLocationHelper';
import flagKeys from '@/constants/flagKeys';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import { toNumber, formatString } from '@/utils/moneyTreatments';
import BillingService from '@/api/BillingService';
import { TextField } from '@/components/atoms';
import TwismWalletEditDate from './TwismWalletEditDate.vue';
import ClockSolidIcon from '@/components/icons/ClockSolid.vue';
import Checked from '@/components/icons/CheckedGreen.vue';

@Component({
  components: {
    Table,
    RowsTable,
    ContextMenu,
    TextInput,
    FilledButton,
    CustomSelect,
    ContentContainer,
    TableFilters,
    TableCell,
    TableHeader,
    TableRow,
    UserIcon,
    Checkbox,
    Typography,
    TextField,
    TwismWalletEditDate,
    ClockSolidIcon,
    Checked
  }
})
export default class TwismWallet extends BasePagination {
  limit = 20;
  service: AdminService = new AdminService();
  serviceBilling: BillingService = new BillingService();
  businessList: List = new List([], []);
  searchableFields = 'searchableFields=business.name';
  sortField = 'coins';
  sortOrder = 'DESC';
  filterValuesSeparator = ':';
  overviewData: any = {};
  autoSendFilterModel: any = [];
  exportLoading: boolean = false;

  detailData: any = {};

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get merchantDashboardReportsIsActive() {
    return this.flags.includes(flagKeys.merchantDashboardReports);
  }

  get overview() {
    return {
      availableCoins: formatString(this.overviewData.availableCoins || ''),
      coinsSentToCustomers: formatString(
        this.overviewData.coinsSentToCustomers || ''
      ),
      coinsSentToCoinStore: formatString(
        this.overviewData.coinsSentToCoinStore || ''
      ),
      lifetimeCoins: formatString(this.overviewData.lifetimeCoins || '')
    };
  }

  get isActivedBillingModuleV3() {
    return this.flags.includes(flagKeys.billingModuleV3);
  }

  getDate(date: string) {
    return DateUtils.formattedDate({
      date
    });
  }

  async handleChangeMitingStartDate(business: any) {
    try {
      const date = new Date(business.auxMitingStartDate);
      date.setHours(0);
      date.setDate(date.getDate() - 1);

      this.$showLoaderWithLocker();
      await this.service.setBillingDelayedPeriod(
        business.id,
        date.toISOString().split('T')[0]
      );
      this.reloadList(true, true, undefined, true);
    } finally {
      this.$hideLoader();
    }
  }

  getConfirmBillingData(business: any, data: any) {
    if (this.isChecked(business)) {
      return {
        subtitle: `Upon confirmation, ${
          business.name
        } will no longer be billed weekly for Coin usage`,
        description: `
        Number of locations: ${data.activeLocations}
        <br />
        Last billed amount: ${data.totalFee} Coins
        <br />
        Last billing date: ${DateUtils.formattedDate({
          date: data.nextPaymentAt
        })}
        `
      };
    }
    return {
      subtitle: `Upon confirmation, ${
        business.name
      } will be billed weekly with ${toNumber(
        data.perLocationFee
      )} Coins per location.`,
      description: `
        Number of locations: ${data.activeLocations}
        <br />
        Initial billing amount: ${data.totalFee} Coins
        <br />
        First billing date: ${DateUtils.formattedDate({
          date: data.nextPaymentAt
        })}
        `
    };
  }

  created() {
    this.initAutoSendFilterModel();
    eventBus.$on('reloadTwismWallet', this.reloadTwismWallet);
    this.loadOverview();
  }

  async exportList() {
    this.exportLoading = true;
    const csvData = await this.service.getExportTwismWalletList({
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      pagination: this.pagination,
      filters: this.query
    });

    const blob = new Blob([csvData.data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'twism_wallet_list.csv');
    document.body.appendChild(link);
    link.click();

    this.exportLoading = false;

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  reloadTwismWallet(loader?: boolean) {
    this.reloadList(
      true,
      true,
      undefined,
      true,
      (list: any[]) => {
        if (this.detailData) {
          const business = list.find(
            item => item.id === this.detailData.data.id
          );
          this.openBusinessDetail({
            ...business,
            notReload: true
          });
        }
      },
      loader
    );
    this.loadOverview();
  }

  getNumber(str: string) {
    return formatString(str);
  }

  initFilterModel() {
    const actionGroup = new CustomSelectGroup([
      new CustomSelectOption('active', `Billing enabled`),
      new CustomSelectOption('inactive', `Disabled`)
    ]);

    this.filterModel = new CustomSelectModel(
      [actionGroup],
      `Filter by charged`,
      false,
      true,
      true,
      false
    );
  }

  initAutoSendFilterModel() {
    const actionGroup = new CustomSelectGroup([
      new CustomSelectOption('1', `Enabled`),
      new CustomSelectOption('0', `Disabled`)
    ]);

    this.autoSendFilterModel = new CustomSelectModel(
      [actionGroup],
      `Filter by auto-send Coin Store`,
      false,
      true,
      true,
      false
    );
  }

  getMaxBillingDate(business: any) {
    const date = new Date(business.subscriptionStartedAt);
    date.setDate(date.getDate() + 90);
    return date.toISOString();
  }

  getBillingMinDate(business: any) {
    return DateUtils.addDays(new Date(business.subscriptionCreatedAt), 7);
  }

  getOptionsByData(business: any) {
    const options: ContextMenuOption[] = [
      {
        label: 'Impersonate',
        action: 'impersonate'
      }
    ];

    Object.keys(EBusinessStatus).forEach(key => {
      const statusesObj = EBusinessStatus as any;
      const item = statusesObj[key];
      if (item === EBusinessStatus.unknown) return;

      if (business.status !== item) {
        options.push({
          label: `Set as ${item}`,
          action: 'setStatus',
          props: [item]
        });
      }
    });

    return options;
  }

  isChecked(business: any) {
    return business.subscriptionStatus === 'active';
  }

  optionSelected(action: string, props: Array<any>, business: any): void {
    switch (action) {
      case 'impersonate':
        this.impersonate(business);
        break;
      case 'setStatus':
        this.setStatus(props[0], business);
        break;
      default:
        break;
    }
  }

  initHeader() {
    const header = [
      new HeaderList(`Business image`, 'none', '0 16px'),
      new HeaderList(`Business name`, 'name', '12px 16px'),
      new HeaderList(`Business location`, 'city', '12px 16px'),
      new HeaderList(`Operation type`, 'type', '12px 16px'),
      new HeaderList(`Locations`, 'locations', '12px 16px'),
      new HeaderList(`Coins available`, 'coins', '12px 16px'),
      new HeaderList(`Status`, 'subscriptionStatus'),
      new HeaderList(`Auto-send Coin Store`, 'autoSendingCoinStore'),
      new HeaderList(``, 'none', '12px')
    ];
    if (this.isActivedBillingModuleV3)
      header.splice(
        -4,
        0,
        new HeaderList(
          `Minting start date`,
          'subscriptionStartedAt',
          '12px 16px'
        )
      );
    this.businessList.header = header;
  }

  setStatus(status: any, business: any) {
    this.$showLoaderWithLocker();
    this.service
      .setBusinessStatus(business.id, { status: status.toLowerCase() })
      .then(res => {
        this.$hideLoader();
        if (res.status === 200) {
          this.$notification(`Business set as ${status} succesfully`);
          this.reloadList(true, true, undefined, true);
        }
      });
  }

  impersonate(business: any) {
    this.service
      .impersonate({
        mail: business.mail,
        business: business.id
      })
      .then(res => {
        const { access_token } = res.data;
        this.service.setCredentials(access_token, true);

        window.location.assign('/home');
      });
  }

  async loadOverview() {
    const { data } = await this.service.getOverview();
    this.overviewData = data;
  }

  reloadList(
    clearList?: boolean,
    refreshCurrent?: boolean,
    query?: string,
    notEmpty?: boolean,
    onFinish?: any,
    loader: boolean = true
  ) {
    if (clearList) {
      this.resetPagination();
      if (!notEmpty) this.businessList.list = [];
      this.maxItems = false;
    }
    if (this.refreshing || this.maxItems) return;
    if (loader) {
      this.$showLoaderWithLocker();
      this.refreshing = true;
    }
    this.service
      .getTwismWalletList({
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pagination: this.pagination,
        filters: this.query
      })
      .then(response => {
        const { data } = response;
        const { items, links } = data;
        if (refreshCurrent) {
          // refresh page and reinitilize pagination
          this.resetPagination();
          this.pagination = decodeURIComponent(links.next);
          if (!links.next) this.maxItems = true;
          this.businessList.list = this.addRowsToList(items);
        } else {
          // refresh page and add items

          this.businessList.list = this.businessList.list.concat(
            this.addRowsToList(items)
          );
          if (!links.next) this.maxItems = true;
          this.pagination = decodeURIComponent(links.next);
        }
        if (onFinish) onFinish(this.businessList.list);
      })
      .catch(() => {})
      .finally(() => {
        if (this.hasLoadedMore && notEmpty) {
          const listElement = this.$refs.list as HTMLElement;
          listElement.scrollTo(0, 0);
          this.hasLoadedMore = false;
        }

        this.$hideLoader();
        this.isLoading = true;
        this.refreshing = false;
      });
  }

  addRowsToList(businessRows: any[]): any[] {
    return businessRows.map((business: any) => ({
      id: business.id,
      picture: business.logo,
      name: business.name,
      mail: business.managerMail,
      managerName: business.managerName,
      phone: business.phone,
      type: business.type,
      address: getBusinessLocationInfo(business),
      subscriptionStatus: business.subscriptionStatus,
      status: EBusinessStatus.active,
      locations: business.locations,
      coins: formatString(business.coins),
      createdAt: DateUtils.formatISODate(business.createdAt),
      lifetimeCoins: business.lifetimeCoins,
      subscriptionPaymentDay: business.subscriptionPaymentDay,
      autoSendingCoinStore: business.autoSendingCoinStore || false,
      mitingStartDate: this.getMitingStartedAt(business),
      auxMitingStartDate: this.getMitingStartedAt(business),
      subscriptionStartedAt: business.subscriptionStartedAt,
      subscriptionDelayedPeriodEndAt: business.subscriptionDelayedPeriodEndAt,
      subscriptionSettingsDelayPeriod: business.subscriptionSettingsDelayPeriod,
      subscriptionCreatedAt:
        business.subscriptionCreatedAt || new Date().toISOString(),
      subscriptionPlanId: business.subscriptionPlanId,
      subscriptionPlanModel: business.subscriptionPlanModel,
      subscriptionPlanFlatFee: business.subscriptionPlanFlatFee,
      subscriptionPlanPerLocationFee: business.subscriptionPlanPerLocationFee,
      subscriptionFee: business.subscriptionFee,
      autoSendingCoinStoreAmount: business.autoSendingCoinStoreAmount
    }));
  }

  getMitingStartedAt(business: any) {
    if (business.subscriptionDelayedPeriodEndAt) {
      return DateUtils.addDays(
        new Date(business.subscriptionDelayedPeriodEndAt),
        1
      ).toISOString();
    }
    return business.subscriptionStartedAt;
  }

  getIsDelayedSubscription(business: any) {
    if (!business.mitingStartDate) return false;
    return new Date() <= new Date(business.mitingStartDate);
  }

  closeModal() {
    eventBus.$emit('closeModal');
  }

  openConfirmationModal(props: any) {
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: 'twismWalletConfirmModal',
        hideCancelButton: false,
        icon: '',
        mobilePositionBottom: true,
        mobileFullScreen: false
      }),
      props
    );
  }

  async openStatusConfirm(business: any) {
    this.$showLoaderWithLocker();

    try {
      const { data, status } = await this.serviceBilling.getBillingSubscription(
        business.id
      );
      this.$hideLoader();

      if (status === 200)
        this.openConfirmationModal({
          title: `Are you sure?`,
          ...this.getConfirmBillingData(business, data),
          onConfirm: async () => {
            await this.serviceBilling.toggleBillingSubscription(
              business.id,
              !this.isChecked(business)
            );
            this.closeModal();
            this.$notification(
              `Weekly billing has been successfully ${
                !this.isChecked(business) ? 'activated' : 'inactivated'
              }`
            );
            this.reloadList(true, true, undefined, true);
          }
        });
    } finally {
      this.$hideLoader();
    }
  }

  openBusinessDetail(event: any) {
    const modalConfig = {
      isOpen: true,
      component: 'adminTwismWalletDetails',
      data: event,
      width: '750px',
      onClose: () => {
        this.detailData = undefined;
      }
    };
    this.detailData = modalConfig;
    eventBus.$emit('setSideModalVisible', modalConfig);
  }

  beforeDestroy() {
    eventBus.$off('reloadTwismWallet', this.reloadTwismWallet);
  }
}
